import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { FC } from 'react';
import { useRouter } from 'shared-routing';

import { PackageDetail } from '@features/packages/pages/Package/PackageDetail';
import { RateDetail } from './RateDetail';
import { RateDetailV2 } from './v2';

export const RateVersion: FC<any> = ({ isPackage, ...props }) => {
  const { query } = useRouter();
  const isV2 = useFeatureIsOn('feature.ecom2');
  if (isV2 && !query.bookingStep) return <RateDetailV2 {...props} />;
  return isPackage ? <PackageDetail {...props} /> : <RateDetail {...props} />;
};
